import {
  RadioCheckedIcon,
  RadioUncheckedIcon,
} from '@/components/icons/customIcons';

export function OptionButton({ option, selected, onClick, children }) {
  const Icon = selected ? RadioCheckedIcon : RadioUncheckedIcon;
  const baseClasses =
    'pl-3 pr-5 py-3 border rounded-lg flex flex-wrap items-center gap-1.5 bg-white';
  const selectedClasses = 'border-midnight-700';
  const unselectedClasses =
    'border-charcoal-200 transition [@media(hover:hover)]:[@media(pointer:fine)]:hover:border-midnight-500 [@media(hover:hover)]:[@media(pointer:fine)]:hover:shadow-button [@media(hover:hover)]:[@media(pointer:fine)]:hover:-translate-y-[4px] [@media(hover:hover)]:[@media(pointer:fine)]:hover:-translate-x-[4px]';

  return (
    <button
      type="button"
      className={`${baseClasses} ${selected ? selectedClasses : unselectedClasses}`}
      onClick={onClick}
      aria-pressed={selected}
    >
      {Icon && (
        <span className={selected ? 'text-midnight-700' : 'text-charcoal-200'}>
          <Icon />
        </span>
      )}
      <span>{option}</span>
      {children}
    </button>
  );
}
